<template>
  <footer class="footer">
    <div class="info-wrapper">
      <div class="copyright">
        <p class="top-line">
          <i class="logo"></i> Copyright 2015-{{ date }} 深圳市迷你玩科技有限公司 , All Rights Reserved.
        </p>
        <p class="bottom-line">
          《网络文化经营许可证》 浙粤网文[2016]1349-302号
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      date: '',
    };
  },
  mounted() {
    this.date = new Date().getFullYear();
  },
};
</script>

<style lang="less" scoped>
.footer {
  height: 160px;
  background: #3a3a3a;

  .info-wrapper {
    display: flex;
    justify-content: center;
    padding-top: 42px;
    text-align: center;
    margin-left: -20px;
  }
  .top-line {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    text-align: center;
    word-break: break-all;
    width: 580px;
    line-height: 1.5;
  }
  .bottom-line {
    line-height: 1.5;
  }
  .logo {
    display: inline-block;
    width: 39px;
    height: 39px;
    // margin-top: -8px;
    // margin-left: 87px;
    background: url(~@/assets/images/logo.png) no-repeat;
    background-size: contain;
  }

  .copyright {
    font-size: 16px;
    margin-left: 10px;
    line-height: 30px;
    text-align: center;
    color: #ffffff;
    .top-line {
      font-size: 16px;
    }
  }
}
</style>
